import { render } from "./BaseLayout.vue?vue&type=template&id=6536c93e&scoped=true&ts=true"
import script from "./BaseLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&setup=true&lang=ts"

import "./BaseLayout.vue?vue&type=style&index=0&id=6536c93e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6536c93e"],['__file',"src/layouts/template/BaseLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6536c93e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6536c93e', __exports__)) {
    api.reload('6536c93e', __exports__)
  }
  
  module.hot.accept("./BaseLayout.vue?vue&type=template&id=6536c93e&scoped=true&ts=true", () => {
    api.rerender('6536c93e', render)
  })

}


export default __exports__